import { render, staticRenderFns } from "./MarksLegalsPg.vue?vue&type=template&id=c519e526&scoped=true&"
import script from "./MarksLegalsPg.vue?vue&type=script&lang=js&"
export * from "./MarksLegalsPg.vue?vue&type=script&lang=js&"
import style0 from "./MarksLegalsPg.vue?vue&type=style&index=0&id=c519e526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c519e526",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
